var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge rounded-full select-none",style:({backgroundColor: _vm.bg, color: _vm.color})},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }